/* eslint-disable no-undef */
import moment from 'moment';
import i18n from "i18next";
import OAuth from '../../constants/OAuth2';
import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";


const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
const LOGIN_FAIL = 'auth/LOGIN_FAIL';
const TOGGLE_EMPLOYEE_VIEW = 'auth/TOGGLE_EMPLOYEE_VIEW';


const AUTH_TOKEN_SUCCESS = 'auth/AUTH_TOKEN_SUCCESS';
const AUTH_TOKEN_FAIL = 'auth/AUTH_TOKEN_FAIL';

const SESSION_CLOSE = 'auth/SESSION_CLOSE';
const SESSION_CLOSE_SUCCESS = 'auth/SESSION_CLOSE_SUCCESS';
const SESSION_CLOSE_FAIL = 'auth/SESSION_CLOSE_FAIL';

const IS_CHECK_TOKEN= 'auth/IS_CHECK_TOKEN';
const IS_CHECK_TOKEN_SUCCESS = 'auth/IS_CHECK_TOKEN_SUCCESS';
const IS_CHECK_TOKEN_FAIL = 'auth/IS_CHECK_TOKEN_FAIL';

const SESSION_LISTS = 'auth/SESSION_LISTS';
const SESSION_LISTS_SUCCESS = 'auth/SESSION_LISTS_SUCCESS';
const SESSION_LISTS_FAIL = 'auth/SESSION_LISTS_FAIL';

const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
const LOGOUT_FAIL = 'auth/LOGOUT_FAIL';

const SET_LANGUAGE = 'auth/SET_LANGUAGE';
const SET_LANGUAGE_SUCCESS ='auth/SET_LANGUAGE_SUCCESS';
const SET_LANGUAGE_FAIL ='auth/SET_LANGUAGE_FAIL';


const initialState = {
  loading: false,
  employeeView: true,
  sessionLists: [],
  user: null,
  isActive:true,
  logout:null,
  error: null,
  language:'tr'
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      const accessToken = action.result.data.access_token;
      const refreshToken = action.result.data.refresh_token;
      const expiresIn = action.result.data.expires_in;

      localStorage.setItem('oauth2Token', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('expiresIn', expiresIn);

      const expireDate = moment(moment.now()).add(parseInt(expiresIn), 'seconds').unix() * 1000;
      const {language, ...userData} = action.result.data
      localStorage.setItem('expireDate', expireDate);
      return {
        ...state,
        loading: false,
        user: { ...userData},
        language
      };
    case LOGIN_FAIL:
      if (window && window.localStorage) {
        localStorage.clear();
      }

      return {
        ...state,
        error: 'Giriş yapılırken bir hata ile karşılaşıldı.',
      };
    case LOGOUT_SUCCESS:
      cookieAndLocalStorage();
      return {
        ...initialState,
      };

    case LOGOUT_FAIL:
      cookieAndLocalStorage();
      return {
        ...state,
        error: 'Çıkış yapılırken bir hata oluştu.',
      };
    case IS_CHECK_TOKEN:
      return {
        ...state,
        loading: true,
      };

    case IS_CHECK_TOKEN_SUCCESS:
      const isActive = action.result.data.isActive;
      if(!isActive){
       cookieAndLocalStorage();
        return{
          ...initialState,
          isActive: false,
          loading: false,
        }

      }
      return {
        ...state,
        isActive: action.result.data.isActive,
        loading: false,
      };
      case IS_CHECK_TOKEN_FAIL:
        return {
          ...initialState
        }
    case SET_LANGUAGE_SUCCESS:
       i18n.changeLanguage(action.result.locale)
       return{
        ...state,
        language: action.result.locale
       };
    case SET_LANGUAGE_FAIL:
       return{
        ...state
       };
    case TOGGLE_EMPLOYEE_VIEW:
      return {
        ...state,
        employeeView: !state.employeeView,
      };
    case SESSION_LISTS:
      return {
        ...state,
      };
    case SESSION_LISTS_SUCCESS:
      return {
        ...state,
        sessionLists: action.result.data,
      };
    case SESSION_LISTS_FAIL:
      return {
        ...state,
        sessionLists: [],
      };
    case SESSION_CLOSE:
      return {
        ...state,
      };
    case SESSION_CLOSE_SUCCESS:
      return {
        ...state,
        sessionLists: state.sessionLists.filter(
          session => !action.payload.some(sess => sess._id === session._id)),
      };
    case SESSION_CLOSE_FAIL:
      return {
        ...state,
      };

    case AUTH_TOKEN_SUCCESS:
      return {
        ...state,
        oauthUser: action.result.data
      };
    case AUTH_TOKEN_FAIL:
      return {
        ...state,
      };
    default:
      return state;
  }
}

export function logout() {
  const token = localStorage.getItem('oauth2Token');
  return {
    types: [null,LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: client => client.post('/user/logout', {
      data: {
        token: token,
      },
    }),
  };
}

export function isCheckToken() {
  const token = localStorage.getItem('oauth2Token');
  return {
    types: [IS_CHECK_TOKEN,IS_CHECK_TOKEN_SUCCESS, IS_CHECK_TOKEN_FAIL],
    promise: client => client.post('/user/token/is-active', {
      data: {
        token: token,
      },
    }),
  };
}

export function toggleEmployeeView() {
  return {
    type: TOGGLE_EMPLOYEE_VIEW,
  };
}

export function sessionLists() {
  return {
    types: [SESSION_LISTS, SESSION_LISTS_SUCCESS, SESSION_LISTS_FAIL],
    promise: client => client.post('/user/session/lists', { data: {} }),
  };
}

export function sessionClose(payload) {
  payload = Array.isArray(payload) ? payload : [payload];

  return {
    types: [SESSION_CLOSE, SESSION_CLOSE_SUCCESS, SESSION_CLOSE_FAIL],
    loading: true,
    payload,
    promise: client => client.post('/user/session/close', {
      data: {
        sessions: payload,
      },
    }),
  };
}

export function login(payload) {
  return {
    types: [null, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: client => client.post('/user/authentication', {
      data: {
        code: payload.code,
        redirectUrl: payload.redirectUrl
      },
    }),
  };
}
export function changeLanguage(language) {
  return {
    types: [SET_LANGUAGE, SET_LANGUAGE_SUCCESS, SET_LANGUAGE_FAIL ],
    promise: client => client.post('/user/change-language', {
      data: {
        language
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/auth.js